module.exports = __webpack_public_path__ + "img/3.efdf9ad4.jpg";